"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _CalendarTable = _interopRequireDefault(require("./CalendarTable"));

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: "flex",
    flexWrap: "wrap"
  },
  month: {
    width: "25%",
    height: "25%"
  },
  table: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    "& thead": {
      display: "flex",
      width: "100%",
      flexDirection: "column"
    },
    "& th": {
      flexBasis: 0,
      flexGrow: 1
    },
    "& th + th": {
      borderLeft: "1px solid",
      borderColor: theme.palette.divider
    },
    "& tbody": {
      display: "flex",
      width: "100%",
      flexDirection: "column",
      flexGrow: 1
    },
    "& tr": {
      display: "flex",
      width: "100%",
      flexBasis: 0,
      flexGrow: 1
    },
    "& tr + tr": {
      borderTop: "1px solid",
      borderColor: theme.palette.divider
    },
    "& td": {
      flexBasis: 0,
      flexGrow: 1
    },
    "& td + td": {
      borderLeft: "1px solid",
      borderColor: theme.palette.divider
    }
  },
  weekday: {
    display: "flex",
    margin: theme.spacing(1),
    alignItems: "center",
    justifyContent: "left",
    fontFamily: "Akkurat, sans-serif",
    fontSize: '12px',
    lineHeight: 1
  },
  date: {},
  dateButton: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    margin: 0,
    fontFamily: "Akkurat, sans-serif",
    fontSize: '12px',
    color: theme.palette.text.disabled,
    lineHeight: 1,
    "&[data-month=true]": {
      color: theme.palette.text.primary
    },
    "&[data-today=true]": {
      border: "1px solid",
      borderColor: theme.palette.primary.main
    },
    "&[data-selected=true]": {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    }
  }
}));

const DateButton = ({
  selected,
  dt,
  dtMonth,
  onClick
}) => {
  const classes = useStyles();
  return _react.default.createElement(_IconButton.default, {
    className: classes.dateButton,
    onClick: onClick,
    "data-selected": selected,
    "data-month": dtMonth
  }, (0, _moment.default)(dt).format('D'));
};

const CalendarMonth = ({
  date,
  monthStart,
  eventsByDate = {},
  onSelect
}) => {
  const classes = useStyles();

  const renderWeekday = ({
    dt,
    weekday
  }) => {
    weekday = weekday.substr(0, 1).toUpperCase();
    return _react.default.createElement("div", {
      className: classes.weekday
    }, weekday);
  };

  const renderDate = ({
    dt,
    dtMonth
  }) => {
    const selected = date === dt;
    const events = eventsByDate && eventsByDate[dt];
    return _react.default.createElement("div", {
      className: classes.date
    }, _react.default.createElement(DateButton, {
      dt: dt,
      dtMonth: dtMonth,
      selected: selected,
      onClick: e => onSelect && onSelect({
        date: dt
      }, e)
    }, (0, _moment.default)(dt).format('D')));
  };

  return _react.default.createElement("div", {
    className: classes.month
  }, (0, _moment.default)(date).format('MMMM'), _react.default.createElement(_CalendarTable.default, {
    dt: monthStart,
    className: classes.table,
    renderWeekday: renderWeekday,
    renderDate: renderDate
  }));
};

const CalendarYear = (_ref) => {
  let year = _ref.year,
      props = _objectWithoutPropertiesLoose(_ref, ["year"]);

  if (!year) {
    year = (0, _moment.default)().format('YYYY');
  }

  const yearStart = (0, _moment.default)(year).startOf('year').format('YYYY-MM-DD');
  const yearEnd = (0, _moment.default)(year).endOf('year').format('YYYY-MM-DD');
  let months = [];

  for (let m = 0; m < 12; m++) {
    let month = (0, _moment.default)(yearStart).add(m, 'months');
    let monthStart = (0, _moment.default)(month).format('YYYY-MM-DD');
    months.push(monthStart);
  }

  const classes = useStyles();
  return _react.default.createElement("div", {
    className: classes.root
  }, months.map(monthStart => {
    return _react.default.createElement(CalendarMonth, _extends({
      monthStart: monthStart
    }, props));
  }));
};

var _default = CalendarYear;
exports.default = _default;
module.exports = exports.default;